// extracted by mini-css-extract-plugin
export var container = "webOptions-module--container--WWT8X";
export var titlesContainer = "webOptions-module--titlesContainer--MMh-B";
export var button = "webOptions-module--button--gA4x0";
export var title = "webOptions-module--title--D6d4A";
export var infoContainer = "webOptions-module--infoContainer--wTIeA";
export var label = "webOptions-module--label--y55a0";
export var list = "webOptions-module--list--Z9i-e";
export var listItem = "webOptions-module--listItem--ZgZ3F";
export var flexItem = "webOptions-module--flexItem--ySEax";